export default __webpack_public_path__ + "static/media/village.a9959aa1.jpg";